import { mutationTree } from "typed-vuex";
import { ActionDefinition } from "@wl/types/lib/types/actions/definition";
import { ActionDefinitionHistory } from "@wl/types/lib/types/actions/history";
import state, { ActionState } from "./state";

/**
 * Action module mutations.
 */
const mutations = mutationTree(state, {
    /**
     * Sets the active action definitions.
     *
     * @param {ActionState} state Actions state
     * @param {ActionDefinition[]} definitions Action definitions
     */
    setActive(state: ActionState, definitions: ActionDefinition[] | undefined): void {
        if (!definitions) return;

        state.active = definitions;
    },

    /**
     * Sets the action definition history.
     *
     * @param {ActionState} state Action state
     * @param {ActionDefinitionHistory[]} history Action definition history
     */
    setHistory(state: ActionState, history: ActionDefinitionHistory[] | undefined): void {
        if (!history) return;

        state.history = history;
    },

    /**
     * Clears the action module state.
     *
     * @param {ActionState} state
     */
    clear(state: ActionState): void {
        state.active = [];
        state.history = [];
    },
});

export default mutations;
